import { Col, FieldFeedback, Row } from '@orobix/orobix-fe-components'
import { Formik, FormikHandlers, FormikHelpers, FormikState } from 'formik'

import { DatasetSelectField } from '../../components/DatasetSelect'
// import { useParams } from 'react-router-dom'
import { ProductType, SelectOption as FormSelectOption } from '../../types'
import { ObservationCompact } from '../../types/observation'
import useStyles from './DatasetImageNewForm.styles'

export type SelectOption = FormSelectOption

type ObservationsMixin = {
  selectedObservations: ObservationCompact[]
}

type DatasetSelectionMixin = {
  dataset: SelectOption
}

type DatasetInfoMixin = {
  name: string
}

export type DatasetImageNewFormValues = ObservationsMixin &
  DatasetInfoMixin &
  DatasetSelectionMixin

interface DatasetImageNewFormProps<T extends DatasetImageNewFormValues> {
  children?: React.ReactNode
  productId: string
  projectId: string
  productType: ProductType
  requiredImages: number
  initialValues: T
  renderRightColumn: (props: {
    values: T
    setFieldValue: FormikHelpers<T>['setFieldValue']
    setFieldTouched: FormikHelpers<T>['setFieldTouched']
    handleBlur: FormikHandlers['handleBlur']
    isSubmitting: FormikState<T>['isSubmitting']
    errors: FormikState<T>['errors']
    touched: FormikState<T>['touched']
  }) => React.ReactNode
  validate: (values: T) => void
  onSubmit?: (values: T, setSubmitting: (isSubmitting: boolean) => void) => void
  showDatasetManager: boolean
  setSelectedDatasets: React.Dispatch<React.SetStateAction<string[]>>
}

const DatasetImageNewForm = <T extends DatasetImageNewFormValues>({
  children,
  productId,
  projectId,
  productType,
  requiredImages,
  initialValues,
  renderRightColumn,
  validate,
  onSubmit,
  showDatasetManager,
  setSelectedDatasets,
}: DatasetImageNewFormProps<T>) => {
  const classes = useStyles()

  // const { projectId: routeProjectId } = useParams<{ projectId: string }>()

  return (
    <Formik<T>
      validateOnMount
      initialValues={initialValues}
      validate={(values) => validate(values)}
      onSubmit={() => undefined}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        isValid,
        submitForm,
      }) => (
        // cannot use <form> tag here, see https://orobix.atlassian.net/browse/AIG-1101
        <div role="form" className={classes.form}>
          <Row noBottomPadding className={classes.row}>
            <Col
              xs={8}
              xl={showDatasetManager ? 9 : 12}
              className={classes.col}
            >
              {children}
            </Col>
            {showDatasetManager && (
              <Col xs={4} xl={3}>
                {renderRightColumn({
                  values,
                  setFieldValue,
                  setFieldTouched,
                  handleBlur,
                  isSubmitting,
                  errors,
                  touched,
                })}

                <div className={classes.flexRow}>
                  <div className={classes.flex1}>
                    <DatasetSelectField
                      fieldName="dataset"
                      productId={Number(productId)}
                      onSelectedDatasets={setSelectedDatasets}
                    />
                  </div>
                </div>

                {!!(
                  errors.selectedObservations &&
                  values.selectedObservations.length > 0
                ) && (
                  <div className={classes.selectedObservationsFeedback}>
                    <FieldFeedback>{errors.selectedObservations}</FieldFeedback>
                  </div>
                )}
              </Col>
            )}
          </Row>
        </div>
      )}
    </Formik>
  )
}

export default DatasetImageNewForm
